var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { X as CloseIcon } from '@untitled-ui/icons-react';
import Select, { components } from 'react-select';
import classNames from 'classnames';
import { Spinner } from '../../spinner';
var ClearIndicator = function (props) {
    return (React.createElement(components.ClearIndicator, __assign({}, props),
        React.createElement(CloseIcon, null)));
};
var MultiValueRemove = function (props) {
    return (React.createElement(components.MultiValueRemove, __assign({}, props),
        React.createElement(CloseIcon, { className: 'h-5 w-5 mr-2' })));
};
var IconControl = function (Icon) { return function (props) { return (React.createElement(components.Control, __assign({}, props),
    Icon && React.createElement(Icon, { className: 'h-5 w-5 mr-2' }),
    props.children)); }; };
var controlStyles = {
    base: "border rounded bg-white hover:cursor-pointer px-3 py-2 ring-1 ring-inset border-0 text-base text-gray-900",
    focus: "shadow-md shadow-primary-100 ring-primary-300",
    nonFocus: "ring-gray-300 ",
    error: "ring-error"
};
var placeholderStyles = "text-gray-400 absolute";
var selectInputStyles = "";
var valueContainerStyles = "gap-1 flex-1 relative";
var singleValueStyles = "ml-1 absolute";
var multiValueStyles = "bg-gray-100 rounded items-center py-0.5 pl-2 pr-1 gap-1.5";
var multiValueLabelStyles = "leading-6 py-0.5";
var multiValueRemoveStyles = "border border-gray-200 bg-white hover:bg-error-50 hover:text-error-800 text-gray-500 hover:border-error-300 rounded-md";
var indicatorsContainerStyles = "gap-1";
var clearIndicatorStyles = "text-gray-400 p-1 -m-1 ml-1 rounded-md hover:bg-error-50 hover:text-error-800";
var indicatorSeparatorStyles = "bg-gray-300 hidden";
var dropdownIndicatorStyles = "h-6 w-6 flex items-center justify-center hover:bg-gray-100 text-gray-500 rounded-md hover:text-black";
var menuStyles = "mt-1 rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 sm:text-sm";
var groupHeadingStyles = "ml-3 mt-2 mb-1 text-gray-500 text-sm";
var optionStyles = {
    base: "hover:cursor-pointer pl-2 pr-6 py-2 rounded",
    focus: "bg-primary-25",
    selected: "after:content-['✔'] bg-gray-50",
};
var noOptionsMessageStyles = "text-gray-500 p-2";
var loadingMessageStyles = "text-gray-500 p-2";
export function AdvancedSelect(_a) {
    var Icon = _a.Icon, error = _a.error, id = _a.id, props = __rest(_a, ["Icon", "error", "id"]);
    var Control = useMemo(function () {
        return IconControl(Icon);
    }, [Icon]);
    return React.createElement(Select, __assign({ closeMenuOnSelect: false, hideSelectedOptions: false, unstyled: true, inputId: id, styles: {
            input: function (base) { return (__assign(__assign({}, base), { "input:focus": {
                    boxShadow: "none",
                } })); },
            // On mobile, the label will truncate automatically, so we want to
            // override that behaviour.
            multiValueLabel: function (base) { return (__assign(__assign({}, base), { whiteSpace: "normal", overflow: "visible" })); },
            control: function (base) { return (__assign(__assign({}, base), { transition: "none" })); },
        }, components: __assign({ Control: Control, ClearIndicator: ClearIndicator, MultiValueRemove: MultiValueRemove, LoadingIndicator: function () { return React.createElement(Spinner, { size: 'sm' }); } }, props.components), classNames: {
            control: function (_a) {
                var isFocused = _a.isFocused;
                return classNames(isFocused ? controlStyles.focus : error ? controlStyles.error : controlStyles.nonFocus, controlStyles.base);
            },
            placeholder: function () { return placeholderStyles; },
            input: function () { return selectInputStyles; },
            valueContainer: function () { return valueContainerStyles; },
            singleValue: function () { return singleValueStyles; },
            multiValue: function () { return multiValueStyles; },
            multiValueLabel: function () { return multiValueLabelStyles; },
            multiValueRemove: function () { return multiValueRemoveStyles; },
            indicatorsContainer: function () { return indicatorsContainerStyles; },
            clearIndicator: function () { return clearIndicatorStyles; },
            indicatorSeparator: function () { return indicatorSeparatorStyles; },
            dropdownIndicator: function () { return dropdownIndicatorStyles; },
            menu: function () { return menuStyles; },
            groupHeading: function () { return groupHeadingStyles; },
            option: function (_a) {
                var isFocused = _a.isFocused, isSelected = _a.isSelected;
                return classNames(isFocused && optionStyles.focus, isSelected && optionStyles.selected, optionStyles.base);
            },
            noOptionsMessage: function () { return noOptionsMessageStyles; },
            loadingMessage: function () { return loadingMessageStyles; },
        } }, props));
}
